// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"TabelColSearch_searchBox__3zsCM","input":"TabelColSearch_input__3jXBJ","button":"TabelColSearch_button__Ycj8V","highlight":"TabelColSearch_highlight__1A7lp"};